import { StandardResponse, UserResponse, UserRole } from "@it-tc/legacy-api";
import emptySplitApi from "./emptySplitApi";

export type GovernmentIssuedIDStatus =
  | "approved"
  | "pending"
  | "rejected"
  | null;
export type User = {
  id: number;
  name: string;
  email: string;
  role: UserRole;
  governmentIssuedId: {
    issuerId: number | null;
    status: GovernmentIssuedIDStatus;
  };
  exams: {
    count: number;
  };
};

const governmentIssuedIdStatusMap = {
  Approved: "approved",
  Pending: "pending",
  Rejected: "rejected",
} as const;

const extendedApi = emptySplitApi.injectEndpoints({
  endpoints: (builder) => ({
    getUser: builder.query<User, undefined>({
      providesTags: ["User"],
      transformResponse: (response: StandardResponse<UserResponse>) => {
        const {
          firstName,
          lastName,
          userId,
          email,
          userRole,
          totalExam,
          idStatus,
          countryId,
        } = response.response;
        return {
          name: `${firstName} ${lastName}`,
          email,
          id: userId,
          role: userRole,
          governmentIssuedId: {
            issuerId: countryId,
            status:
              idStatus === null ? null : governmentIssuedIdStatusMap[idStatus],
          },
          exams: {
            count: totalExam,
          },
        };
      },
      query: () => ({
        url: `${location.origin}/individualexamscheduler/services/common/v1/common/user.json?userId=0`,
      }),
    }),
  }),
});

export const { useGetUserQuery, useLazyGetUserQuery } = extendedApi;
